export const stripPunctuation = (word: string): string =>
  word
    .replace(
      // eslint-disable-next-line no-useless-escape
      /(?:[\(\)\-&$#!\[\]{}\"\',«»\.¿—;%\^\*\-\+`~]+(?:\s|$)|(?:^|\s)[\(\)\-&$#!\[\]{}\"\',«»\.¿—;%\^\*\-\+`~]+)/g,
      '',
    )
    .replace('?', '')
    .trim()

export const clean = (word: string): string =>
  stripPunctuation(word).toLocaleLowerCase()
